// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import "babel-polyfill"
import Vue from 'vue'
import App from './App'
import router from './router'
import store from "./store/index";

import baseUrl from './api/baseUrl'
import comm from "./utils/common";
import local from "./utils/localStorage";
import {Request} from "./utils/request";
import './utils/permission'

//阿里图标
import './assets/fonts/aliIcon/iconfont.css'

// import echarts from "echarts";
//echarts按需引入
var echarts = require('echarts/lib/echarts');
require("echarts/lib/chart/lines");
require("echarts/lib/component/dataset");
require("echarts/lib/chart/line");
require("echarts/lib/chart/scatter");
require("echarts/lib/chart/radar");
require("echarts/lib/chart/map");
require("echarts/lib/chart/funnel");
require("echarts/lib/chart/boxplot");
require("echarts/lib/chart/effectScatter");
require("echarts/lib/chart/pictorialBar");
require("echarts/lib/chart/themeRiver");
require("echarts/lib/chart/sunburst");
require("echarts/lib/chart/custom");
require("echarts/lib/component/graphic");
require("echarts/lib/component/grid");
require("echarts/lib/component/tooltip");
require("echarts/lib/component/geo");
require("echarts/lib/component/title");

Vue.prototype.$echarts = echarts;

Vue.config.productionTip = false

require('promise.prototype.finally').shim(); //解决低版本不兼容finally的问题


Vue.prototype.$A = comm;  //通用工具方法
Vue.prototype.$L = local; // 本地相关操作
Vue.prototype.$Request = Request;//axios
Vue.prototype.$baseUrl = baseUrl;//axios


let that = new Vue({
	el: '#app',
	mode: 'history',
	router,
	store,
	components: {App},
	template: '<App/>'
}).$mount('#app');
export default that;



// WEBPACK FOOTER //
// ./src/main.js